import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CardModal, CardModalType, CardModalNotOkButton } from "../../modal"
import { Word } from "../../../model";
// import './style.scss'


export default class PolitiqueModal
extends React.Component<PolitiqueModalProps> {
	render() {
		const onClickAddWordModalCloseButton  = this.props.onClickCloseButton
		const onClickAddWordModalFooterButton = this.props.onClickFooterButton
		const onSubmitAddWordModal            = this.props.onSubmit
		const submitting                      = this.props.submitting
		const errors                          = this.props.errors

		return (
			<CardModal active
			           loading={submitting}
			           onClickCloseButton={onClickAddWordModalCloseButton}
			           onClickFooterButton={onClickAddWordModalFooterButton}
			           onSubmit={onSubmitAddWordModal}
			           title="Ajouter un mot au glossaire"
			           type={CardModalType.ValidCancel}>
				<div className="columns is-mobile">
					<div className="column field">
						<label className="label" htmlFor={Names.POLITIQUE}>Politique</label>
						<p className={`control ${submitting ? "is-loading" : ""}`}>
							<input className={`input ${errors.Politique ? "is-danger": ""}`}
							       disabled={submitting}
							       id={Names.POLITIQUE}
							       name={Names.POLITIQUE}
							       min={0}
							       required
							       type="text" />
							{/* <span className="icon is-left">
								<i className="fas fa-comment-alt" />
							</span> */}
						</p>
						{errors && errors.Politique && <p className="help is-danger">{errors.Politique}</p>}
					</div>
				</div>
			</CardModal>
		)
	}
}

export namespace Names {
	export const POLITIQUE       = "Politique"
	export const ID              = "id"

}

export interface PolitiqueModalProps {
	errors?            : PolitiqueModalErrors
	onClickCloseButton : (event: React.SyntheticEvent<Element>) => void
	onClickFooterButton: (button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>) => void
	onSubmit           : (event: React.SyntheticEvent<Element>) => void
	submitting         : boolean
}

export interface PolitiqueModalErrors {
	Politique?      : string
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/politique-modal.tsx